// Orquestra a edição da descrição: qual configuração está no diálogo, o envio
// pelo service e o fechamento só quando o gateway confirma — com erro, o
// diálogo fica aberto com o texto digitado (o toast explica a falha).
import { useState } from "react"

import { useUpdatePaymentConfigurationDescriptionMutation } from "@/services/payment-configurations"
import type { PaymentConfiguration } from "@/types/payment-configurations"

export const usePaymentConfigurationDescriptionEdit =
  () => {
    const [editing, setEditing] =
      useState<PaymentConfiguration | null>(null)
    const mutation =
      useUpdatePaymentConfigurationDescriptionMutation()

    const submit = (description: string) => {
      if (!editing) return
      mutation.mutate(
        { id: editing.id, description },
        { onSuccess: () => setEditing(null) }
      )
    }

    return {
      editing,
      isSubmitting: mutation.isPending,
      open: (configuration: PaymentConfiguration) =>
        setEditing(configuration),
      close: () => setEditing(null),
      submit,
    }
  }
